
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stocks/category/[categorySlug]",
      function () {
        return require("private-next-pages/stocks/category/[categorySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stocks/category/[categorySlug]"])
      });
    }
  